import { transitionEndEventName } from './utility';

export default function tab() {
  const $tab = $('.js-tab');

  $tab.each((index, element) => {
    const $tabLabel = $(element).children();

    $tabLabel.each((labelIndex, labelElement) => {
      const $element = $(labelElement);
      const targetHash = $element.find('a')[0].hash;

      $element.data('tabContent', $(document).find(targetHash));
    });

    const $contentsWrapper = $tabLabel
      .eq(0)
      .data('tabContent')
      .closest('.js-tab-content');

    $contentsWrapper.on(`${transitionEndEventName.event}.tab`, event => {
      if (event.currentTarget === event.target) {
        $contentsWrapper.css('height', '');
      }
    });
    $tabLabel.on('click', event => {
      const $currentTarget = $(event.currentTarget);

      event.preventDefault();
      if (!$currentTarget.hasClass('_current')) {
        const $prevLabel = $tabLabel.filter('._current').eq(0);
        const $nextLabel = $currentTarget;
        const $prevTabContent = $prevLabel.data('tabContent');
        const $nextTabContent = $nextLabel.data('tabContent');
        const startHeight = $prevTabContent.outerHeight();

        $contentsWrapper.css('height', `${startHeight}px`);
        $prevLabel.add($prevTabContent).removeClass('_current');
        $nextLabel.add($nextTabContent).addClass('_current');

        const endHeight = $nextTabContent.outerHeight();

        if (startHeight === endHeight) {
          $contentsWrapper.css('height', '');
        } else {
          // eslint-disable-next-line no-unused-expressions
          $contentsWrapper.offsetHeight; // reflow
          $contentsWrapper.css('height', `${endHeight}px`);
        }
      }
    });
  });
}
